import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { awsHealthMonitorApiRef, AwsHealthMonitorClient } from './api';

export const awsHealthMonitorPlugin = createPlugin({
  id: 'aws-health-monitor',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: awsHealthMonitorApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new AwsHealthMonitorClient(discoveryApi, fetchApi),
    }),
  ],
});

export const AwsHealthMonitorPage = awsHealthMonitorPlugin.provide(
  createRoutableExtension({
    name: 'AwsHealthMonitorPage',
    component: () =>
      import('./components/HealthMonitorPage').then(m => m.HealthMonitorPage),
    mountPoint: rootRouteRef,
  }),
);
